<template>
  <div v-if="containsCode" class="grouped-entity-card-wrapper">
    <div class="card-title-wrapper">
      <img :src="getIconURL" style="height: 40px; width: 40px; margin-right: 10px" />
      <div class="grouped-card-title" @click="$emit('titleClick')">{{ cardTitle }}</div>
      <div class="see-all-btn" @click="$emit('titleClick', cardTitle)">See All</div>
    </div>
    <div class="card-body">
      <div v-for="item of getTopEntities">
        <div v-if="getEntityName(item)" class="list-entity">
          <div class="entity-name" v-on:click="$emit('entityTitleClicked', item)">
            {{ getEntityName(item) }}
          </div>
          <!-- <div class="highlight">{{ getEntityHighlight(item) }}</div> -->
          <div class="grouped-entity-date">{{ formatDate(item) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '../utils/helpers'
import get from 'lodash/get'
import Constants from '../utils/constants.js'

export default {
  name: 'GroupedEntityCard',
  data () {
    return {
      icon: ''
    }
  },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    cardTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    getIconURL() {
      if (this.dataList) {
        let type = this.dataList[0].type
        let icon = Constants.iconByCategory[type]
        return icon ? require(`../statics/icons/${icon}.svg`) : ''
      }
    },
    containsCode() {
      return this.dataList.some(i => this.getEntityName(i))
    },
    getTopEntities() {
      let topFive = this.dataList.slice(0, 5)
      return topFive
    },
    getRemining() {
      let totalLength = this.dataList.length
      return totalLength - 5
    }
  },
  methods: {
    getEntityName(entity) {
      let name = ''
      name = get(entity, 'data.code.name', '')
      return name ? name : get(entity, 'data.codes[0].name', '')
    },
    formatDate(entity) {
      let options = { year: '2-digit', month: '2-digit', day: '2-digit' }
      return Helpers.ciiFormatDate(entity.eventDate, options)
    },
    getEntityHighlight(entity) {
      let highlight = ''
      return highlight
    }
  }
}
</script>

<style>
.grouped-entity-card-wrapper {
  margin: 24px 0;
  background: #ffffff;
  border: 1px solid #C9CBD5;
  border-radius: 8px;
}

.card-body {
  display: flex;
  flex-direction: column;
  padding: 0 16px;
}

.grouped-card-title {
  text-transform: capitalize;
  font-weight: 600;
  font-size: 18px;
  flex-grow: 1;
}

.card-title-wrapper {
  background: #ECF8F7;
  border-radius: 7px 7px 0px 0px;
  padding: 16px 16px 15px 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.grouped-card-title:hover {
  cursor: pointer;
  text-decoration: underline;
}

.list-entity {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #E5E6EE;
  padding: 16px 0;
}

.entity-name {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

.entity-name:hover {
  text-decoration: underline;
}

.highlight {
  width: 210px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 13px;
  margin: 0 16px;
}

.grouped-entity-date {
  color: #565963;
  font-weight: 400;
  font-size: 14px;
}

.see-all-btn {
  font-weight: 600;
  font-size: 14px;
  color: #128279;
}

.see-all-btn:hover {
  cursor: pointer;
  text-decoration: underline;
}

@media only screen and (max-width: 600px) {
  .list-entity {
    display: flex;
    width: inherit;
    justify-content: space-between;
  }

  .entity-name {
    max-width: 185px;
    font-weight: 700;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
  }
}

@media only screen and (max-width: 320px) {
  .entity-name {
    max-width: 230px;
    font-size: 12px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
  }
}
</style>
